export const formatDateTimeCET = (dateString) => {
  if (!dateString) return "Unknown";

  const date = new Date(dateString);

  if (isNaN(date)) return "Invalid date";

  return date.toLocaleString("en-GB", {
    timeZone: "Europe/Belgrade",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
};
